/* --------------------------------------------------------------------------------
    *   responsive_royalslider.METHOD({PARAMS});
    
    Diese Params * muessen uebergeben werden.
    Alle andern koennen ueberschrieben werden, falls sie vom Default abweichen.
    PARAMS: 
        {   
            debug: false,
    *       this: '##d.area_div_id#.royalSlider',
            fade_out_time: 1,
            fade_in_time: 800,
            img_max_width: 1140,
            txt_max_width: 302,
            txt_max_height: 280,
            classname_fontsize: 'fproz_',
            calc_prozent: 100,

            imageScaleMode: 'fill',
            autoScaleSliderWidth: 1140,     
            autoScaleSliderHeight: 280,
            transitionType: 'fade',
            autoPlay_delay: 1000, // (1000 = 1sec).
            numImagesToPreload: 4,
            imgWidth: 1140,
            imgHeight: 280,
            area_default_imgpath: '#application.config.site_webroot#/img/layout/slideshow_vorlage_startpage.jpg'
        }

    METHODS:
    * init
        - Royalslider Initialisieren / Bilder laden
        Bsp.:
            responsive_royalslider.init({PARAMS});
        Return: ---
    * resize_window
        - Royalslider animierter Block ausblenden bei Bildschirmgroesse Anpassung
        Bsp.:
            responsive_royalslider.resize_window({PARAMS});
    * show_textbox
        - Royalslider animierter Block anzeigen
        Bsp.:
            responsive_royalslider.show_textbox({PARAMS});
----------------------------------------------------------------------------------- */
var responsive_royalslider = (function() {
        "use strict"; // Preventing you from using undeclared variables. IE 9 will not throw an error even if it does not understand it.

        // --------------------------------------------------------------------------------
        //  *   Private Vars
        //  -------------------------------------------------------------------------------
        var params = {
            debug: false,
            this: null,
            fade_out_time: 1,
            fade_in_time: 800,
            img_max_width: 1140,
            txt_max_width: 280,
            txt_max_height: 280,
            classname_fontsize: 'fproz_',
            calc_prozent: 100,

            imageScaleMode: 'fill',
            autoScaleSliderWidth: 1140,     
            autoScaleSliderHeight: 280,
            transitionType: 'fade',
            autoPlay_delay: 1000, // (1000 = 1sec).
            numImagesToPreload: 4,
            imgWidth: 1140,
            imgHeight: 280,
            area_default_imgpath: ''
        };

        var settings = $.extend({} ,params),
            debug = settings.debug,
            $this = null;

        // --------------------------------------------------------------------------------
        //  *   Public Methods
        //  -------------------------------------------------------------------------------
        var init = function(params) {
            set_params(params);
            initialize();

            if (debug==true){
                console.log('----- responsive_royalslider: initialize ----------'); 
                console.log('settings');console.log(settings);
                console.log('$this');console.log($this);
            }

            var returnValue = false;
            try {
                returnValue = get_instance();
            }
            catch(err) {
                if (settings.area_default_imgpath.length > 0) {
                    $this.find('.rsImg').attr('href', settings.area_default_imgpath);
                }
                returnValue = get_instance();
            }

            return returnValue;
        };

        var resize_window = function(params) {
            set_params(params);
            initialize();
            if (debug==true){console.log('----- responsive_royalslider: resize_window ----------');console.log('settings');console.log(settings);}
            if( $this.find('.content').length ) {
                $this.find('.content').fadeOut(settings.fade_out_time, function() {});
            }
        };

        var show_textbox = function(params) {
            set_params(params);
            initialize();
            if (debug==true){console.log('----- responsive_royalslider: show_textbox ----------');console.log('settings');console.log(settings); console.log('$this'); console.log($this)}
            
            if ( $('body').hasClass('view_mnu_hamburger') == true) {
                if (debug==true){console.log('Body Class: view_mnu_hamburger'); }
                $this.find('.slide_textbox .rsSlideText').removeClass('yes-visible').addClass('no-visible');
            }
            else {
                $this.find('.slide_textbox .rsSlideText').removeClass('no-visible').addClass('yes-visible');
            }
            

            /* obsolete ReZ Textbox Berechnung
            if( $this.find('.content').length ) {
                // ========== * Text Content Groesse setzen * ======================================================================
                set_textbox_size();
                
                // ========== * Bestehenden Classnamen entfernen (fproz_) * ======================================================================
                var calc_cl_proz = get_calc_prozent_ceiling(settings.calc_prozent),
                    elm_class = $this.find('.content').attr('class'),
                    remove_class_val = 'dsp_svg',
                    arr_class = (elm_class != undefined && elm_class.length) ? elm_class.split(" ") : [];

                $.each(arr_class, function(idx, val) {
                    if (val.toLowerCase().indexOf(settings.classname_fontsize.toLowerCase()) >= 0) {
                        remove_class_val += (remove_class_val.length > 0) ? " "+ val : ""+ val ;
                    }
                });

                if ( remove_class_val.length > 0 ) {
                    $this.find('.content').removeClass(remove_class_val);
                }
                // ========== * end: Bestehenden Classnamen entfernen (fproz_ etc.) * ======================================================================

                // ========== * Klassen hinzufuegen (fproz_ etc.) * ======================================================================
                $this.find('.content').addClass(settings.classname_fontsize+calc_cl_proz);

                if (calc_cl_proz <= 50 ) {
                    // nothing to do
                }
                else {
                    $this.find('.content').addClass('dsp_svg');
                }
                // ========== * end: Klassen hinzufuegen (fproz_ etc.) * ======================================================================

                $this.find('.content').fadeIn(settings.fade_in_time, function() {});
            }
            */
        };

        
        // --------------------------------------------------------------------------------
        //  *   Private Methods
        //  -------------------------------------------------------------------------------
        var set_params = function() {
            $.each(Array.prototype.slice.call(arguments), function(i, val) {
                if (typeof val == 'object' ) {
                    settings = $.extend(params, val);
                }
                else {
                    var key = 'param_'+i,
                        obj = {};
                        obj[val] = val;
                        obj[key] = val;
                    
                    settings = $.extend(params, obj);
                }
            });
            debug = settings.debug;
        };

        var initialize = function() {
            $this = $(settings.this);
        };

        var get_instance = function() {
            return $this.royalSlider({
                    arrowsNav: false,
                    keyboardNavEnabled: false,
                    controlsInside: false,
                    imageScaleMode: settings.imageScaleMode,
                    arrowsNavAutoHide: false,
                    autoScaleSlider: true, 
                    autoScaleSliderWidth: settings.autoScaleSliderWidth,     
                    autoScaleSliderHeight: settings.autoScaleSliderHeight,
                    controlNavigation: 'none',
                    thumbsFitInViewport: false,
                    navigateByClick: true,
                    startSlideId: 0,
                    transitionType: settings.transitionType,
                    globalCaption: false,
                    deeplinking: {
                        enabled: true,
                        change: false
                    },
                    autoPlay: {
                        // autoplay options go gere
                        enabled: true,
                        pauseOnHover: false,
                        stopAtAction: false,
                        delay: settings.autoPlay_delay
                    },
                    transitionSpeed: 1000, // Slider transition speed, in ms.,
                    loop: true, //  false   Makes slider to go from last slide to first.
                    numImagesToPreload: 4,
                    slidesOrientation: 'horizontal', // Can be 'vertical' or 'horizontal'.  
                    /* size of all images http://help.dimsemenov.com/kb/royalslider-jquery-plugin-faq/adding-width-and-height-properties-to-images */
                    imgWidth: settings.imgWidth,
                    imgHeight: settings.imgHeight
                });
        };

        var set_textbox_size = function() {
            var calc_prozent    = 100,
                calc_proz_cl    = calc_prozent,
                img_max_width   = settings.img_max_width,
                img_act_width   = $this.width(),
                img_act_height  = $this.outerHeight(false),
                txt_max_width   = settings.txt_max_width,
                txt_max_height  = settings.txt_max_height,              
                txt_act_width   = txt_max_width,
                txt_act_height  = txt_max_height;
                
            if (debug==true){console.log('----- responsive_royalslider: set_textbox_size ----------');console.log('settings');console.log(settings);}

            if ( ( img_max_width > 0 && img_act_width > 0) && img_max_width > img_act_width ) {
                calc_prozent = parseInt( eval( (100 / img_max_width) * img_act_width) );
                calc_proz_cl = get_calc_prozent_ceiling(calc_prozent);
            }
            settings.calc_prozent=calc_prozent;
            
            if ( calc_prozent < 100 ) {
                txt_act_width   = Math.ceil( eval( (txt_max_width / 100) * calc_prozent) );
                txt_act_height  = Math.ceil( eval( (txt_max_height / 100) * calc_prozent) );
            }
            if (calc_proz_cl <= 50 ) {
                txt_act_width  = Math.ceil( eval( (img_act_width / 100) * 50) );
            }
            if (calc_proz_cl <= 30 ) {
                txt_act_width  = Math.ceil( eval( (img_act_width / 100)  * 60) );
                txt_act_height = Math.ceil( eval( (img_act_height / 100) * 70) );   
            }
            if (calc_proz_cl <= 20 ) {
                txt_act_width  = Math.ceil( eval( (img_act_width / 100)  * 80) );
                txt_act_height = Math.ceil( eval( (img_act_height / 100) * 80) );   
            }
            if (calc_proz_cl <= 10 ) {
                txt_act_width  = img_act_width;
                txt_act_height = img_act_height;
            }

            $this.find('.content').css({'width':txt_act_width+'px', 'height':txt_act_height+'px'});
        };

        var get_calc_prozent_ceiling = function(calc_prozent) {
            return parseInt( Math.floor(eval(calc_prozent / 10)) * 10 );
        };

        // --------------------------------------------------------------------------------
        //  *   Public Methods API (Aufruf)
        //  -------------------------------------------------------------------------------
        return {
            init: init,
            resize_window: resize_window,
            show_textbox: show_textbox
        };
    })( jQuery );// ---------- * end: responsive_royalslider * --------------------